<template>
  <div class="col-md-4 col-12">
    <q-card class="full-height" flat bordered>
      <q-card-section class="q-pa-xs" :class="`bg-${color}`"></q-card-section>
      <q-card-section class="q-pa-lg">
        <div class="flex justify-between">
          <div class="text-h5 text-weight-medium q-my-auto">{{ title }}</div>
          <q-icon :name="icon" size="lg" :color="color" class="q-my-auto"></q-icon>
        </div>
      </q-card-section>
      <q-separator />
      <q-card-section class="q-pa-lg">
        <div v-if="description" class="q-mb-xl">{{ description }}</div>
        <slot></slot>
        <q-btn
          v-if="!hideAction"
          :id="to ? 'intercom-action' : undefined"
          :disable="disable"
          :href="href"
          :color="color"
          class="full-width"
          :to="to"
          no-caps
          unelevated
          :target="href ? '_blank' : undefined"
          size="large"
          @click="$emit('click')"
        >
          {{ actionLabel }}
        </q-btn>
      </q-card-section>
    </q-card>
  </div>
</template>

<script lang="ts">
export default {
  name: 'DashboardCard',
  components: {},
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: undefined
    },
    to: {
      type: Object,
      default: undefined
    },
    href: {
      type: String,
      default: undefined
    },
    actionLabel: {
      type: String,
      default: undefined
    },
    disable: {
      type: Boolean,
      default: false
    },
    hideAction: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  emits: ['click']
}
</script>
